export default __webpack_public_path__ + "static/image4-995c73f1c5b1c629f3895b5508f2f41a.jpg";